exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".typing-text-input[data-v-588d1814]{border:1px solid #aaa;border-radius:10px;padding:8px 10px;width:140px;font-size:.85rem;color:#064160;font-weight:700}", ""]);

// exports
